export const LAST_PATH_STORAGE_KEY = 'xceed-pro-last-path';

/**
 * Get the last visited venue path from localStorage
 */
export const getLastPathCookie = (): string | null => {
  try {
    return localStorage.getItem(LAST_PATH_STORAGE_KEY);
  } catch (error: unknown) {
    console.error('Error getting path from localStorage:', error);
    return null;
  }
};

/**
 * Set the last visited venue path in localStorage
 */
export const setLastPathCookie = (path: string): void => {
  try {
    // Make sure we have a valid path
    if (!path) {
      console.error('Missing path for localStorage');
      return;
    }

    localStorage.setItem(LAST_PATH_STORAGE_KEY, path);
  } catch (error: unknown) {
    console.error('Error setting path in localStorage:', error);
  }
};

/**
 * Remove the last visited path from localStorage
 */
export const removeLastPathCookie = (): void => {
  try {
    localStorage.removeItem(LAST_PATH_STORAGE_KEY);
  } catch (error: unknown) {
    console.error('Error removing path from localStorage:', error);
  }
};
